import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCurrentUser, updateUserProfile, getCurrentProfile } from 'services/api';
import type { UserProfileBody } from 'services/api';

/**
 * Legacy: needs to remove
 */
export const getProfileAction = createAsyncThunk('profile/get', async () => {
  try {
    return await getCurrentUser();
  } catch (e: unknown) {
    throw new Error(e as string);
  }
});

/**
 * Legacy: needs to remove
 */
export const updateProfileAction = createAsyncThunk(
  'profile/update',
  async (nextProfileBody: UserProfileBody, { getState }) => {
    try {
      const {
        profileState: { profile },
      } = getState() as any;
      return await updateUserProfile(profile!.id, nextProfileBody);
    } catch (e: unknown) {
      throw new Error(e as string);
    }
  },
);

export const getCurrentProfileAction = createAsyncThunk('profile/getCurrentProfile', async () => {
  try {
    return await getCurrentProfile();
  } catch (e: unknown) {
    throw new Error(e as string);
  }
});
